
import React, { useEffect } from 'react';

const LeadForm: React.FC = () => {
  useEffect(() => {
    // Check if script already exists
    const scriptId = 'lead-connector-form-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = "https://link.msgsndr.com/js/form_embed.js";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      // We generally keep the script globally once loaded to prevent re-initialization flickers
    };
  }, []);

  return (
    <section id="contact" className="py-32 bg-[#F4E4C1] border-y-8 border-[#1A4D2E]">
      <div className="max-w-5xl mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] font-black uppercase tracking-[0.4em] text-sm mb-4 block">Secure Your Scaling Strategy</span>
          <h2 className="text-5xl md:text-8xl font-black mb-6 uppercase text-[#0F1419] italic tracking-tighter leading-[0.85]">Join The Elite <br /> 200+ Tree Pros</h2>
          <p className="text-xl md:text-2xl text-[#4E3629] font-black uppercase tracking-tight italic opacity-80">
            Fill out the form below to claim your White-Glove Onboarding slot.
          </p>
        </div>
        
        <div className="bg-white rounded-[3rem] shadow-[0_50px_100px_rgba(26,77,46,0.3)] overflow-hidden border-4 border-[#1A4D2E] h-[850px] relative">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#1A4D2E] via-[#FF6B35] to-[#4E3629]" />
          <iframe
            src="https://api.leadconnectorhq.com/widget/form/c6YCkRyzQVewStCiT1uJ"
            style={{ width: '100%', height: '100%', border: 'none' }}
            id="inline-c6YCkRyzQVewStCiT1uJ" 
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="10 jobs in 30 days + Call form"
            data-height="786"
            data-layout-iframe-id="inline-c6YCkRyzQVewStCiT1uJ"
            data-form-id="c6YCkRyzQVewStCiT1uJ"
            title="10 jobs in 30 days + Call form"
          />
        </div>
        
        <div className="mt-12 flex flex-wrap justify-center gap-8 opacity-50 grayscale transition-all hover:grayscale-0">
          <p className="text-[10px] font-black uppercase tracking-widest text-[#4E3629]">SECURE 256-BIT ENCRYPTION</p>
          <p className="text-[10px] font-black uppercase tracking-widest text-[#4E3629]">GDPR & CCPA COMPLIANT</p>
          <p className="text-[10px] font-black uppercase tracking-widest text-[#4E3629]">NO-SPAM GUARANTEE</p>
        </div>
      </div>
    </section>
  );
};

export default LeadForm;
